import { Component, Input } from '@angular/core';

@Component({
  selector: 'em-image-spinner',
  styleUrls: ['./image-spinner.component.less'],
  templateUrl: './image-spinner.component.html',
  standalone: false,
})
export class ImageSpinnerComponent {
  public imageError = false;
  public loading = false;
  public url?: string;
  @Input() public alt?: string;

  @Input() public set src(url: string) {
    this.imageError = false;
    this.loading = true;
    this.url = url;
  }
}
